/** Merge assignment API result into a list row without refetching. */
export function patchRfqRowAfterUserAssignment(row, result) {
  if (!row || !result) return row;
  const managerId =
    result.assignedLogisticsManagerAccessUserId ?? row.assignedLogisticsManagerAccessUserId;
  return {
    ...row,
    assignedLogisticsManagerAccessUserId: managerId,
    assignedLogisticsUserAccessUserId: result.assignedLogisticsUserId,
    assignedLogisticsUserId: result.assignedLogisticsUserId,
    assignedLogisticsUserName: result.assignedLogisticsUserName,
    assignedLogisticsUserEmail: result.assignedLogisticsUserEmail,
    logisticsUserAssignmentType: result.logisticsUserAssignmentType || "manual",
    assignedToUserAt: result.assignedAt,
    assignedAt: result.assignedAt,
    assignedBy: result.assignedBy,
    assignedByName: result.assignedByName,
    status: result.workflowStatus || "in_review",
  };
}
